import { apiService } from '@/services/api';
import type { ConversationCard } from '@/types/dashboard';

class NewTicketService
{
  /**
   * Submit de ticket
   */
  async PostConversationOtherTenant(requestGroupConversation: ConversationCard): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(
        '/ConversationTicketController/PostConversationOtherTenant',
        requestGroupConversation,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error to post the ticket:', error);
      throw error;
    }
  }
  /**
   * Get Projects By ConfigValueId
   */
  async GetProjectsByConfigValueId(configValueId: number): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(
        `/project/getProjectsByConfigValueId?configValueId=${configValueId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error to post the ticket:', error);
      throw error;
    }
  }
}

export const newTicketService = new NewTicketService();
